function f(t) {
  const e = {
    ru: {
      h: "р",
      e: "у",
      c: "с"
    }
  };
  let o = "";
  for (const r of t) {
    let n = !1;
    for (const c in e)
      if (e[c][r]) {
        o += e[c][r], n = !0;
        break;
      }
    n || (o += r);
  }
  return o;
}
export {
  f as decodeSearchQuery
};
